import type { PlayerModalPlayerData } from '@shared/playerApiTypes';
import type { PlayerDossierSeed } from '@/hooks/PlayerDossierProvider';
import { normalizeFcAdminTarget } from '@/lib/fcAdminTarget';

export const playerModalDossierSeed = (player?: PlayerModalPlayerData): PlayerDossierSeed | undefined => {
    const target = normalizeFcAdminTarget(player?.dossierTarget, player?.permanentId ?? undefined);
    if (!target || !player) return undefined;
    return { ...target, name: player.displayName };
};
